export const Facebook = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.55556C1 2.59189 2.59189 1.00001 4.55555 1.00001V1.00001H13.4444V1.00001C15.4081 1.00001 17 2.59189 17 4.55558V13.4444C17 15.4081 15.4081 17 13.4444 17V17H4.55555V17C2.59188 17 1 15.4081 1 13.4444L1 4.55556Z"
        stroke="currentColor"
      />
      <path
        d="M12 5H8.95122C8.30081 5 7 5.52277 7 7.61386C7 9.70495 7 14.7426 7 17"
        stroke="currentColor"
      />
      <line x1="4" y1="10.5" x2="11" y2="10.5" stroke="currentColor" />
    </svg>
  )
}
